<script>
    import { onMount } from 'svelte';
    import { goto } from '@roxi/routify';
    import Chart from 'chart.js/auto';
    import chartService from '../../../../services/chart.js';

    export let cwes = [];
    let canvas;
    let chart;
    let has_data = false;

    onMount(async () => {
        let ctx = canvas.getContext('2d');

        if(cwes.length){
            has_data = true;
        }

        // needed for chart tooltips
        let cwesById    = {};
        cwes.forEach(cwe => cwesById[cwe.id] = cwe);

        let cweTops     = cwes.splice(0, 10);
        let cweOtherSum = cwes.reduce((acc, cwe) => acc + cwe.count, 0);

        let chartData = {
            labels   : [],
            datasets : {
                //backgroundColor : ["#fb383bA6", "#f33639A6", "#eb3437A6", "#e33235A6", "#db3033A6", "#d32f31A6", "#cb2d2fA6", "#c32b2dA6", "#bb292bA6", "#b32729A6"],
                backgroundColor: ["rgba(151, 56, 59, 0.7)", "rgba(89, 89, 89, 0.7)", "rgba(170, 36, 39, 0.7)", "rgba(109, 109, 109, 0.7)",  "rgba(191, 56, 59, 0.7)", "rgba(129, 129, 129, 0.7)",   "rgba(221, 56, 59, 0.7)", "rgba(159, 159, 159, 0.7)", "rgba(251, 56, 59, 0.7)", "rgba(179, 179, 179, 0.7)"],
                borderColor     : '#a4a4a4',
                borderWidth     : 1,
                data: [],
                title: []
            },
        }

        cweTops.forEach(cweTop => {
            chartData.labels.push(`${cweTop.key}`);
            chartData.datasets.title.push(cweTop.description);
            chartData.datasets.data.push(cweTop.count);
        });

        chart   = new Chart(ctx, {
            type: 'polarArea',
            options: {
                responsive: true,

                plugins: {
                    legend: {
                        position: 'right',
                        fontFamily: 'Montserrat'
                    },
                    title: {
                        display: false,
                        text: 'Chart.js Horizontal Bar Chart'
                    },
                    tooltip:{
                        legend: {
                            position: 'right',
                            fontFamily: 'Montserrat'
                        },
                        callbacks: {
                            title: function(tooltipItem) {
                                let index = tooltipItem[0].dataIndex;
                                let title = tooltipItem[0].dataset.title[index]
                                return title;
                            }
                        }
                    },
                },
                scales: {
                    r: {
                        grid: {
                            color: "#666",
                            font: {
                                size: 16,
                                color: '#666'
                            }
                        },
                    }
                },
                /*onHover : (event) => {
                    if((event.chart.tooltip.title && event.chart.tooltip.title != "Otros")){
                        canvas.style.cursor =  "pointer";
                    }
                    else{
                        canvas.style.cursor = "default";
                    }
                },
                onClick : (event) => {
                    if (!event.chart.tooltip.title || event.chart.tooltip.title == "Otros" ) return;
                    let url = "/cwe/" + event.chart.tooltip.title;
                    $goto(url);
                },*/
            },
            data : {
                labels  : chartData.labels,
                datasets: [chartData.datasets]
            },
        });
    });
</script>
<style>
    #chart-top-cwe {
        height: 480px !important;
        margin: 0 auto;
    }
</style>
<canvas bind:this={canvas} id="chart-top-cwe" class:chart-has-no-data="{!has_data}"></canvas>
